import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import { getTZDate, getTZDateAsString } from '../utils/DateUtils';
import { Link } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import '../App.css';

const MOTDList = () => {
  const [motds, setMotds] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  
  const fetchMotds = async () => {
    let now = new Date();
    now.setHours(0, 0, 0, 0);
    const mdate = getTZDate(now, user._site.timezone);
    const dateStr = mdate.toISOString().split('T')[0];
    const params = {
      _site: user._site._id,
      datestr : {$gte: dateStr},
    };
    rpc({
      method: "GetMotds",
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess: setMotds
    });
  };
  const fetch = useCallback(fetchMotds, [user]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const onCreate = () => {
    navigate('/createMotd');
  };

  const onDefault = () => {
    navigate('/defaultMotd');
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  return (
    <div className="MOTDList">
      <Typography variant="h6" gutterBottom>
        Message Of The Day
      </Typography>
      <TableContainer className="TableContainer" component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Message Date</b></TableCell>
              <TableCell><b>Message</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {motds.map((motd, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Link to={`/motd/${motd._id}`}>{getTZDateAsString(motd.date, user._site.timezone)}</Link>
                </TableCell>
                <TableCell>{motd.motd}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="HorizontalContainer">
        <Button className="Button" variant="contained" color="primary" onClick={onCreate}>
          Create
        </Button>
        <Button className="Button" variant="contained" color="primary" onClick={onDefault}>
          Default
        </Button>
      </div>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default MOTDList;
